import React, { Component } from 'react';
import { CircularProgress } from 'material-ui';
import moment from 'moment';
import api from '../../../lib/api';
 
import {
  Title,
  GetCompanyIdContainer,
  FormSection,
  InputSection,
  DetailsOfInput,
  InputTilte,
  InputSubtitle,
  InputFieldWithSubmit,
  Input,
  GetCompanyIdButton,
  ResultSection,
  CompanyDetails,
  DetailTitle,
  DetailData,
  LoaderContainer
} from './styles';

class GetCompanyId extends Component {
  constructor(props) {
    super(props);

    this.state = {
      phone: '',
      email: '',
      catalougeLink: '',
      loading: false,
      error: false,
      errorMessage: '',
      serarchQuery: '',
      data: []
    };
  }

  updateValue = event => {
    event.preventDefault();
    const updatedState = { ...this.state };
    updatedState[event.target.name] = event.target.value;
    this.setState(updatedState);
  };

  getCompanyIdDetails = async key => {
    if (!this.state[key].trim()) {
      return alert('Please enter valid value');
    }
    this.setState({
      loading: true,
      serarchQuery: `Search query : ${this.state[key]}`
    });
    try {
      const result = await api.getCompanyIdFromRemote(key, this.state[key]);
      this.setState({
        error: Array.isArray(result.rows) && result.rows.length === 0,
        errorMessage: 'No details found',
        data: result.rows,
        loading: false
      });
      window.scrollTo(
        0,
        document.getElementById('resultSection').offsetTop - 150
      );
    } catch (error) {
      this.setState({
        error: true,
        data: [],
        loading: false,
        errorMessage:
          (error && error.response && error.response.data) || 'Failed to load'
      });
      window.scrollTo(
        0,
        document.getElementById('resultSection').offsetTop - 150
      );
    }
  };

  handleKeyDown = event => {
    if (event.key === 'Enter') {
      this.getCompanyIdDetails(event.target.name);
    }
  };

  renderResultSection = () => {
    const { data, loading, error, errorMessage } = this.state;
    if (loading) {
      return (
        <LoaderContainer>
          <CircularProgress size={20} thickness={5} color="primary" />
        </LoaderContainer>
      );
    }

    if (error) {
      return (
        <CompanyDetails hideBorder={true}>
          <DetailTitle>{errorMessage}</DetailTitle>
        </CompanyDetails>
      );
    }

    return (
      Array.isArray(data) &&
      data.map((companyDetail, index) => (
        <CompanyDetails
          key={companyDetail.companyId}
          hideBorder={index === data.length - 1}
        >
          <DetailTitle>Company ID</DetailTitle>
          <DetailData margin={'20px'}>
            {companyDetail.companyId || ''}
          </DetailData>
          <DetailTitle>Company name</DetailTitle>
          <DetailData margin={'11px'}>
            {companyDetail.companyName || ''}
          </DetailData>
          <DetailData margin={'0px'}>
            Last seen:{' '}
            {companyDetail.lastSeen &&
              moment(companyDetail.lastSeen).format('ll, h:mm:ss a')}
          </DetailData>
        </CompanyDetails>
      ))
    );
  };

  render() {
    const { phone, email, catalougeLink, loading, serarchQuery } = this.state;
    return (
      <GetCompanyIdContainer>
        <FormSection>
          <Title>Get company ID</Title>
          <InputSection>
            <DetailsOfInput>
              <InputTilte>Catalogue link</InputTilte>
              <InputSubtitle></InputSubtitle>
            </DetailsOfInput>
            <InputFieldWithSubmit>
              <Input
                value={catalougeLink}
                name="catalougeLink"
                onChange={this.updateValue}
                onKeyDown={this.handleKeyDown}
              />
              <GetCompanyIdButton
                loading={loading}
                disabled={loading}
                onClick={() => this.getCompanyIdDetails('catalougeLink')}
              >
                Get company ID
              </GetCompanyIdButton>
            </InputFieldWithSubmit>
          </InputSection>
          <InputSection>
            <DetailsOfInput>
              <InputTilte>Phone number</InputTilte>
              <InputSubtitle>Ex : +918104064645</InputSubtitle>
            </DetailsOfInput>
            <InputFieldWithSubmit>
              <Input
                value={phone}
                name="phone"
                onChange={this.updateValue}
                onKeyDown={this.handleKeyDown}
              />
              <GetCompanyIdButton
                loading={loading}
                disabled={loading}
                onClick={() => this.getCompanyIdDetails('phone')}
              >
                Get company ID
              </GetCompanyIdButton>
            </InputFieldWithSubmit>
          </InputSection>
          <InputSection>
            <DetailsOfInput>
              <InputTilte>Email</InputTilte>
              <InputSubtitle>Ex : steve@apple.com</InputSubtitle>
            </DetailsOfInput>
            <InputFieldWithSubmit>
              <Input
                value={email}
                name="email"
                onChange={this.updateValue}
                onKeyDown={this.handleKeyDown}
              />
              <GetCompanyIdButton
                loading={loading}
                disabled={loading}
                onClick={() => this.getCompanyIdDetails('email')}
              >
                Get company ID
              </GetCompanyIdButton>
            </InputFieldWithSubmit>
          </InputSection>
        </FormSection>
        <ResultSection id={'resultSection'}>
          {serarchQuery && <CompanyDetails>{serarchQuery}</CompanyDetails>}
          {this.renderResultSection()}
        </ResultSection>
      </GetCompanyIdContainer>
    );
  }
}

export default GetCompanyId;



// WEBPACK FOOTER //
// ./src/pages/SalesUtility/GetCompanyId/index.js